import React from "react";
import { Offcanvas, Tabs, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { hideNavUserAction } from "../store/actions/showNavUserAction";
import Login from "./Login";
import Register from "./Register";
import UserMenu from "./UserMenu";

function UserControl({ setUserControlShow }) {
  const user = useSelector((state) => state.user_auth);
  const showUserNav = useSelector((state) => state.showNavUser);
  const dispatch = useDispatch()

  return (
    <Offcanvas show={showUserNav} onHide={() => dispatch(hideNavUserAction())} placement="end">
      <Offcanvas.Header closeButton>
        <div className="p-3"></div>
        <div className="d-block text-center">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="1.3rem"
            height="1.3rem"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M16.848 12.168c1.56-1.32 2.448-3.216 2.448-5.232 0-3.768-3.072-6.84-6.84-6.84s-6.864 3.072-6.864 6.84c0 2.016 0.888 3.912 2.448 5.232-4.080 1.752-6.792 6.216-6.792 11.136 0 0.36 0.288 0.672 0.672 0.672h21.072c0.36 0 0.672-0.288 0.672-0.672-0.024-4.92-2.76-9.384-6.816-11.136zM12.432 1.44c3.048 0 5.52 2.472 5.52 5.52 0 1.968-1.056 3.792-2.76 4.776l-0.048 0.024c0 0 0 0-0.024 0-0.048 0.024-0.096 0.048-0.144 0.096h-0.024c-0.792 0.408-1.632 0.624-2.544 0.624-3.048 0-5.52-2.472-5.52-5.52s2.52-5.52 5.544-5.52zM9.408 13.056c0.96 0.48 1.968 0.72 3.024 0.72s2.064-0.24 3.024-0.72c3.768 1.176 6.576 5.088 6.816 9.552h-19.68c0.264-4.44 3.048-8.376 6.816-9.552z"></path>
          </svg>
          <Offcanvas.Title>{user ? user.firstName : "Mi cuenta"}</Offcanvas.Title>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {user.token ? (
          <UserMenu />
        ) : (
          <Tabs
            defaultActiveKey="login"
            id="uncontrolled-tab-example"
            className="mb-3 menu_control"
          >
            <Tab eventKey="login" title="Entrar">
              <Login setUserControlShow={setUserControlShow} />
            </Tab>
            <Tab eventKey="register" title="Registro">
              <Register setUserControlShow={setUserControlShow} />
            </Tab>
          </Tabs>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default UserControl;
